import React from "react"
import { color, font, generateClassName, Text, Title } from "@smoothincorg/smooth-ui"
import styled from "styled-components"
import { AiFillEdit, AiFillDelete } from "react-icons/ai"
import { boxShadow } from "src/lib/styles/variable"

export type MemoType = {
  body: "test"
  created_at: "2022-02-28T16:55:25.000+09:00"
  id: 1
  memoable_id: 4
  memoable_type: "Smoother"
  title: "test"
  updated_at: "2022-02-28T16:55:25.000+09:00"
  user_id: 6
}

type Props = {
  className?: string
  openMemoForm?: (memo: MemoType) => void
  destroyMemo?: (memo: MemoType) => void
  memo: MemoType
  smoother?: {
    name: string
  }
}

const { getRootClassName, className } = generateClassName("Memo")

const Component: React.FC<Props> = (props) => {
  const memo = props.memo

  return (
    <div className={getRootClassName(props)}>
      <Title as="h4" size={16} weight="bold">
        {memo.title}
      </Title>

      <div className={`${className}__meta`}>
        {props.smoother && <Text size={14}>作成者: {props.smoother.name || "不明"}</Text>}
      </div>

      <div className={`${className}__body`}>{memo.body}</div>

      <div className={`${className}__actions`}>
        <AiFillEdit onClick={() => props.openMemoForm(props.memo)} />
        <AiFillDelete onClick={() => props.destroyMemo(props.memo)} />
      </div>
    </div>
  )
}

export const Memo = styled(Component)`
  background-color: ${color.lightGray};
  padding: 4px 8px;
  border-radius: 4px;
  ${boxShadow.normal};

  .${className} {
    &__meta {
      display: flex;
      > * {
        margin-right: 6px;
      }
    }

    &__body {
      ${font(14)};
      padding: 4px 2px;
    }

    &__actions {
      svg {
        margin-right: 4px;
        width: 20px;
        height: 20px;
      }
    }
  }
`
